module.exports = __webpack_public_path__ + "img/957-a1afe8.png";